var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthBgRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 342 174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-accent-last",
    d: "M131 114.5c-2.3-1.2-4.3-.6-6.5 1.7 1-5.7 1-12.5-3.4-13.7-4.6-1.2-7.2 1.7-9.9 8.7.1-6-1-13.7-6-14-5.4-.4-7.2 4.2-8.6 14.3C95 106 90.2 96 84.6 98c-5.3 2-5 7.2-2 18-3-4.6-9-11.6-12.9-9-3.8 2.6-2.7 6.6 1.5 14.2-2.8-1.2-5.7-1.3-8 1-5.2 5.2-2.7 10 4.5 19.2 7.2 9.1 58.8-7 61.2-11.1 2.5-4.2 6.3-13.4 2.1-15.7z",
    fill: "none",
    stroke: "#FFC1EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.4 130v-.1l-69.3.2v.1a7.2 7.2 0 00-4.5 3 7.3 7.3 0 00-1.2 5.3l5.2 33.9 70.3-.2 5.2-34a7.2 7.2 0 00-5.7-8.2z",
    fill: "#DAEDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "svg-fill-accent-first",
    d: "M245 117.8c-1 0-2.1 0-3.2.2-5.7-8.1-12.3-15-19.3-19.3-18-11.3-43-8-66.1.6-16 6-36.1 25.3-49 38.9-17 1.3-30 13-29.2 26.3.2 2.8 1 5.6 2.3 8.1l56.7.4.3-.5 84-.3.3.4h46.5a35.6 35.6 0 007-21.4c0-18.4-13.6-33.4-30.3-33.4z",
    fill: "#81B4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M224.2 99.8a74.3 74.3 0 01-53 11.6 64.7 64.7 0 01-22.6-8.3l-1.4.8a70.6 70.6 0 0048.4 8.8 83 83 0 0029.8-12l-1.2-1zM222 123c3.3-5 7.5-7.7 12.4-8.2 1.8-.2 3.6 0 5.3.4l-1.3-1.8a18.9 18.9 0 00-17.6 8.6l-.2.6a.7.7 0 00.8.6.7.7 0 00.5-.3zM222.2 140l.5-.1c.2-.2.2-.3.2-.5 0-2.2 1-7 3.9-11.7 3.4-5.3 8.5-8.6 15-9.8l-1-1.3a23.2 23.2 0 00-15.2 10.3 25.9 25.9 0 00-4 12.7.7.7 0 00.6.5zM120 132.9c-2.7-.2-5.5 0-8.2.6l-2 2.2c2.6-1.5 17.8-3.4 24.1 3.9a.7.7 0 001 0 .7.7 0 00.1-1c-4-4.6-11.1-5.6-15-5.7z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.4 143.4c-8.5-6.6-19.1-7-23.6-6.8l-1.5 1.6a37.5 37.5 0 0124.8 6.5c.2 0 .3-.2.5-.3a.7.7 0 00-.2-1z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7 172.4s7.9-23.7 30.1-19.4a649.2 649.2 0 0152.7 13.5v6l-82.8-.1z",
    fill: "#fff",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M271.4 84.8a4 4 0 01-2-3c-.3-2 1.1-11.1 3.4-12.4a75.2 75.2 0 0114.3-6.7c1.9.1 2.7 16.7-15.7 22.1z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 70.4c3.8-13.5 7-16.5 8.7-15.2 1.6 1.2-1.7 9.8-2.6 14.3",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M272.5 70.4c3.8-13.5 7-16.5 8.7-15.2 1.6 1.2-1.7 9.8-2.6 14.3",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M289.3 67.5c2-3.1 5-3 3.4 2.4-1.6 5.2-2.8 12-5.8 15l-4.1 4.5s-6 22.8-9.4 41.8c-5 27.4-14.3 32.7-23 29.6-8.8-3.2-10.4-15.6 1.5-39.7 12-24 18.2-38.1 18.2-38.1",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M289.3 67.5c2-3.1 5-3 3.4 2.4-1.6 5.2-2.8 12-5.8 15l-4.1 4.5s-6 22.8-9.4 41.8c-5 27.4-14.3 32.7-23 29.6-8.8-3.2-10.4-15.6 1.5-39.7 12-24 18.2-38.1 18.2-38.1",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M270.3 83.4c-1.7-1.2-1.5-8-3.4-11-2.5-3.8-4.8-7.7-.4-7 3.9.4 5.1 3.8 6 5",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M270.3 83.4c-1.7-1.2-1.5-8-3.4-11-2.5-3.8-4.8-7.7-.4-7 3.9.4 5.1 3.8 6 5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M287 73.2s3.5-8.3 4.6-12.2c1.2-4.2-3.1-4.8-5.3 1.2",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M287 73.2s3.5-8.3 4.6-12.2c1.2-4.2-3.1-4.8-5.3 1.2",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M283 71s6.8-15.3 3.8-16.7c-2.7-1.2-4.8 4.4-8.3 15.2",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M283 71s6.8-15.3 3.8-16.7c-2.7-1.2-4.8 4.4-8.3 15.2",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M173.9 82.2l1 17.3s-1.6 9.3 11.1 7.6c12.8-1.8 11.2-9.4 11.2-9.4l-4-21.5-19.3 6z",
    fill: "#fff",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M198.2 54.4s9.8-3.7 10.2 6.7c.4 10.5-10.2 7.8-10.2 7.8",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M198.2 54.4s9.8-3.7 10.2 6.7c.4 10.5-10.2 7.8-10.2 7.8",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M172.6 38h17c2.5 0 5 1 6.7 2.8a9.6 9.6 0 012.7 6.8v20.2c0 5.2-2 10.2-5.7 13.9a19.3 19.3 0 01-31.6-6.4c-1-2.4-1.5-5-1.5-7.5V50.6c0-3.3 1.3-6.5 3.7-8.9 2.3-2.3 5.4-3.7 8.7-3.7h0z",
    fill: "#fff",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "svg-fill-accent-last",
    d: "M203.5 77c0-4.2-.3-8.5-1.1-12.7v-.2c0-.8-.3-1.5-.9-2-.5-.5-1.2-.8-1.9-.8v5.6c.6 0 1.2-.2 1.6-.6 1 5.6 2.7 22.4-4.7 36.7l-4 7.3c-7 13.2-11.5 22-11.4 29.8 0 .2 0 .4.2.5l.5.2c.2 0 .4 0 .5-.2l.2-.5c0-7.4 4.5-16 11.3-29l4-7.4a57.9 57.9 0 005.7-26.6zM158.3 67.2l1.1.3V62a2.7 2.7 0 00-2.4 2.3l-.2.4c0 1.2 0 27.5 7.8 39.4a53.6 53.6 0 0111 31.4l.6.2c.2 0 .4-.1.5-.3l.2-.5c-.6-12.1-3-19.2-11.1-31.6-6.2-9.5-7.3-29.3-7.5-36.1z",
    fill: "#FFC1EE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M173.7 56l.2 15.8s1.2 1.7 3-1.7M173.7 75.2c1.4 1.7 4.7 1.4 8-.8 0 0 1.3 4.3-5.1 4.9M179.8 50.9c.2 0 2.3-3.1 5.5-.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M185.3 62.5c.6 0 1.2-.8 1.2-1.9 0-1-.6-1.8-1.2-1.8-.7 0-1.2.8-1.2 1.8s.5 2 1.2 2zM167.7 63c.7 0 1.2-.8 1.2-1.9 0-1-.5-1.9-1.2-1.9-.6 0-1.2.9-1.2 2 0 1 .6 1.8 1.2 1.8z",
    fill: "currentColor"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M164 50.7c.1 0 2.7-3.6 5.3-.2",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 33.8c-4.7 0-8.3.3-10.4.7-17.3 4-14.5 16.9-14.5 16.9s8.4 1.6 15.3-8.7c0 0 9.4 7.8 23.4 11l.7-.2v.7c1.2-.3 2.4-.5 3.6-.4-.2-5.1-1.1-11.5-5.3-15.7-2.9-3-7.2-4.4-12.8-4.3z",
    fill: "currentColor"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M203.3 52.6c-.6-6.5-2-19.4-18-19.6a81 81 0 00-10.7.6",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M229.8 23.1c-6-17.2-22.9-27-37.8-21.7C179.8 5.8 172.7 19 174 33c2.2-.4 5.7-.6 10.4-.7 6 0 10.7 1.5 14 4.8 4.5 4.5 5.5 11.5 5.6 17 2.2.6 4.3 2.4 4.4 7l-.3 4c0 1.5.4 2.9 1.1 4 1.7 2.8 5 4.5 10.1 5l.6-.1a.7.7 0 00-.4-1.3c-4.6-.5-7.6-2-9-4.3a6 6 0 01-.9-2.7c1.3 1.5 3.4 3 6.8 3a12.8 12.8 0 003-.4.7.7 0 00.3-.7.7.7 0 00-.6-.6h-.3c-4.4 1-6.9-.8-8.1-2.3l2.9-.8c14.9-5.3 22.1-23.5 16.2-40.8z",
    fill: "currentColor"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M186.3 70c4.9 0 8.9-4 8.9-8.9 0-5-4-9-8.9-9-4.8 0-8.8 4-8.8 9s4 9 8.8 9zM171.5 60.9h5.8M194 56.8l5-2.9M162.4 70c5 0 8.9-4 8.9-8.9 0-5-4-9-8.9-9-4.8 0-8.8 4-8.8 9s4 9 8.8 9z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "svg-fill-accent-last",
    d: "M223.1 163.2h-5l-2.4-37a5.1 5.1 0 00-1.6-3.3 5 5 0 00-3.4-1.3h-69.9a4.2 4.2 0 00-4 2.9c-.3.6-.4 1.2-.3 1.8l2.7 40.9c.1 1.3.7 2.4 1.6 3.3a5 5 0 003.4 1.4l79-.1a2.6 2.6 0 002.4-1.6l.2-1v-3.3a2.7 2.7 0 00-1.7-2.5l-1-.2z",
    fill: "#FFC1EE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M180.7 146a7 7 0 00-3.7-2c.2-.4.4-.8.4-1.2 0-.6-.1-1.2-.5-1.7s-1-.9-1.6-1a11 11 0 00-1.4-3.4.8.8 0 00-1-.2.5.5 0 00-.2.4.5.5 0 00.2.4c.4.5.8 2 1.1 3a2.3 2.3 0 00-1.2 1.9 2.6 2.6 0 00.7 2c-.4 0-.8.3-1.2.5-2.5 1.6-2.8 4.7-.7 7a7 7 0 008.4 1.3c2.5-1.5 2.8-4.7.7-7zM179.6 136.6s-3.6-.7-4 2.3c0 0 2.8 1 4-2.3z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1 172.6h340",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBgRight);
export default __webpack_public_path__ + "static/media/auth-bg-right.757b07824ddff2fb1680d36616fab2bc.svg";
export { ForwardRef as ReactComponent };